import React, {useEffect} from 'react';
import companySwitcherSelectors from "@legacy/components/common/CompanySwitcher/selectors";
import userSelectors from "@legacy/helpers/users/selectors";
import {useSelector} from "react-redux";
import LoadingIndicator from "@legacy/components/common/LoadingIndicator";
import styled from "styled-components";
import ReloadCompaniesLink from "@legacy/components/common/CompanySwitcher/Reload/reloadCompanies";

const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    
    svg {
        width: 32px;
        height: 32px;
    }
`;

const Reload = ({ fetchCompanies }) => {
    const showReload = useSelector(companySwitcherSelectors.showReload);
    const isReload = useSelector(companySwitcherSelectors.isReload);
    const user = useSelector(userSelectors.user);

    useEffect(() => {
        if(isReload === true){
            fetchCompanies(user, true);
        }
    }, [isReload]);

    return showReload ? (
        <li>
            {
                isReload ? (
                    <LoadingContainer>
                        <LoadingIndicator loading={ true } />
                    </LoadingContainer>
                ) : (
                    <ReloadCompaniesLink />
                )
            }
        </li>
    ) : null;
}

export default Reload;